<template>
  <div>
    <Toolbar :handle-edit="() => editHandler(item)" :hasAccess="userHasAccess('tool_edit')" >
      <template slot="left">
        <v-toolbar-title v-if="item" class="hidden-md-and-down toolbartitle_50" >
          <h1><v-icon large>mdi-tools</v-icon>{{ item['name'] }}</h1>
        </v-toolbar-title>
      </template>
    </Toolbar>

    <br />

    <div v-if="item" class="table-tool-show">
      <v-simple-table>
        <template slot="default">
          <thead>
            <tr>
              <th>{{ $t('global.field') }}</th>
              <th>{{ $t('global.value') }}</th>

              <th>{{ $t('global.field') }}</th>
              <th>{{ $t('global.value') }}</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td><strong>{{ $t('profile.tool.name') }}</strong></td>
              <td>
                                    {{ item['name'] }}
              </td>

              <td><strong>{{ $t('profile.tool.number') }}</strong></td>
              <td>
                {{ $n(item['number']) }}              </td>
            </tr>

            <tr>
              <td><strong>{{ $t('profile.tool.toolheaddef') }}</strong></td>
              <td>
                                    {{ item['toolHeadDef'] }}
              </td>

              <td><strong>{{ $t('profile.tool.comment') }}</strong></td>
              <td>
                                    {{ item['comment'] }}
              </td>
            </tr>

            <tr>
              <td><strong>{{ $t('profile.tool.extruder') }}</strong></td>
              <td>
                <ul>
                  <li v-for="_item in item['extruders']" :key="_item.id">
                    {{ _item.name }}
                  </li>
                </ul>
              </td>

              <td><strong>{{ $t('profile.tool.heater') }}</strong></td>
              <td>
                <ul>
                  <li v-for="_item in item['heater']" :key="_item.id">
                    {{ _item.name }}
                  </li>
                </ul>
              </td>
            </tr>
            <tr>
              <td><strong>{{ $t('global.archive') }}</strong></td>
              <td>
                            {{ item['archive'] }}
              </td>
            </tr>

          </tbody>
        </template>
      </v-simple-table>
    </div>

    <Loading :visible="isLoading" />
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import { mapFields } from 'vuex-map-fields';
import Loading from '../../components/Loading';
import ShowMixin from '../../mixins/ShowMixin';
import AccessMixin from '../../mixins/AccessMixin';
import Toolbar from '../../components/Toolbar';

const servicePrefix = 'Tool';

export default {
  name: 'ToolShow',
  servicePrefix,
  components: {
      Loading,
      Toolbar
  },
  mixins: [ShowMixin,AccessMixin],
  computed: {
    ...mapFields('tool', {
      isLoading: 'isLoading'
    }),
    ...mapGetters('tool', ['find'])
  },
  methods: {
    ...mapActions('tool', {
      deleteItem: 'del',
      reset: 'reset',
      update: 'update',
      retrieve: 'load'
    })
  }
};
</script>
